export default __webpack_public_path__ + "static/media/Nunito-ExtraLightItalic.880c89ca.woff2";